<template>
    <form>
        <slot/>
        <button type="submit" class="hidden"/>
    </form>
</template>

<script setup>

</script>
